import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { useRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { IconDeleteOutline } from '@icons/IconDeleteOutline'
import { IconEditOutline } from '@icons/IconEditOutline'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { toast } from 'sonner'
import { AgentForm } from '../../Forms/AgentForm'
import { useCurrentApplication } from '../../useCurrentApplication'

type MessagesAgentExistingAgent = RestSchemas['Messages.Agent.ExistingAgent']

export function AgentCardActionsMenu({ agent }: { agent: MessagesAgentExistingAgent }) {
  const { applicationId } = useCurrentApplication()
  const { getAgentApiGetAgents, deleteAgentApiDeleteAgent } = useRestClient()

  const invalidateAgents = () => {
    getAgentApiGetAgents.invalidateQueries({ parameters: { path: { applicationId } } })
  }

  const { mutate: deleteAgent } = deleteAgentApiDeleteAgent.useMutation(undefined, {
    onSuccess: () => {
      invalidateAgents()
      toast.success('Agent successfully deleted')
    },
    onError: () => {
      toast.error('Error deleting agent')
    },
  })

  const handleDeleteAgent = () => {
    deleteAgent({
      path: {
        applicationId,
        agentId: agent.id,
      },
    })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon" className="size-8 justify-self-end">
          <IconMenuOutline size={16} />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        onCloseAutoFocus={(e) => {
          e.preventDefault()
        }}
      >
        <DropdownMenuLabel>Actions</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <AgentForm
          selectedAgent={agent}
          sheetTitle="Edit Agent"
          sheetDescription="Edit the agent"
          onSubmit={invalidateAgents}
          sheetTrigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconEditOutline size={16} />
                <span>Edit agent</span>
              </div>
            </DropdownMenuItem>
          }
        />
        <ConfirmDialog
          title="Confirm Delete"
          description="Are you sure you want to delete this agent?"
          onConfirm={handleDeleteAgent}
          confirmVariant="destructive"
          trigger={
            <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
              <div className="flex items-center gap-2">
                <IconDeleteOutline size={16} />
                <span>Delete agent</span>
              </div>
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
